module.exports = __webpack_public_path__ + "media/images/games/k2gender/teacher-acc1a8062c8a499f27c150b155bb7d29.png";